module.exports = __webpack_public_path__ + "static/beauty-gems-logo_white-acb752b730ddae903e9264e091ff138a.png";